import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ImageWithLoader } from 'app/components';
import { ListEntitySubtitle } from './styles';

const propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  poster: PropTypes.string,
  to: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string
  }).isRequired
};

const defaultProps = {
  title: null,
  subTitle: null,
  poster: null
};

const ListEntityInner = ({ to, title, subTitle, poster }) => {
  const [t] = useTranslation();

  return (
    <NavLink className="l-entity__item-link" to={to}>
      <ImageWithLoader imgSrc={poster} imgTitle={title} />
      <figcaption className="l-entity__figure-caption">{title || t('movies.no_title')}</figcaption>
      {subTitle ? <ListEntitySubtitle>{subTitle}</ListEntitySubtitle> : null}
    </NavLink>
  );
};

ListEntityInner.propTypes = propTypes;
ListEntityInner.defaultProps = defaultProps;
export default ListEntityInner;
